/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CampaignDurationStatusDTO
 */
export interface CampaignDurationStatusDTO {
  /**
   *
   * @type {number}
   * @memberof CampaignDurationStatusDTO
   */
  percentage: number | null;
  /**
   *
   * @type {string}
   * @memberof CampaignDurationStatusDTO
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof CampaignDurationStatusDTO
   */
  startInAmountOfDays: number;
}

/**
 * Check if a given object implements the CampaignDurationStatusDTO interface.
 */
export function instanceOfCampaignDurationStatusDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "percentage" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "startInAmountOfDays" in value;

  return isInstance;
}

export function CampaignDurationStatusDTOFromJSON(json: any): CampaignDurationStatusDTO {
  return CampaignDurationStatusDTOFromJSONTyped(json, false);
}

export function CampaignDurationStatusDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CampaignDurationStatusDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    percentage: json["percentage"],
    name: json["name"],
    startInAmountOfDays: json["startInAmountOfDays"]
  };
}

export function CampaignDurationStatusDTOToJSON(value?: CampaignDurationStatusDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    percentage: value.percentage,
    name: value.name,
    startInAmountOfDays: value.startInAmountOfDays
  };
}
